export const addDays = (date, daysToAdd) => {
  const now = date.getTime();
  return new Date(now + daysToAdd * 24 * 60 * 60 * 1000);
};
